
import { useEffect } from 'react';
import Hero from './components/Hero';
import CompanyOverview from './components/CompanyOverview';
import Business from './components/Business';
import Recruit from './components/Recruit';
import News from './components/News';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: '株式会社鈴電エンジニア',
      url: siteUrl,
      address: {
        '@type': 'PostalAddress',
        streetAddress: '伏黒字上ケ戸71-6',
        addressLocality: '伊達市',
        addressRegion: '福島県',
        postalCode: '960-0501',
        addressCountry: 'JP',
      },
      telephone: '024-583-4612',
      foundingDate: '1979-01-13',
      description:
        '株式会社鈴電エンジニアは、電気設備工事を中心に、空調・消防設備工事など、建物に関わる各種設備工事を行っています。',
    },
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: siteUrl,
      name: '株式会社鈴電エンジニア',
      publisher: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'ja',
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/`,
      url: `${siteUrl}/`,
      name: '株式会社鈴電エンジニア',
      description:
        '株式会社鈴電エンジニアは、電気設備工事を中心に、空調・消防設備工事など、建物に関わる各種設備工事を行っています。',
      isPartOf: { '@id': `${siteUrl}/#website` },
      about: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'ja',
    },
    {
      '@type': 'LocalBusiness',
      '@id': `${siteUrl}/#localbusiness`,
      name: '株式会社鈴電エンジニア',
      url: siteUrl,
      telephone: '024-583-4612',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '伏黒字上ケ戸71-6',
        addressLocality: '伊達市',
        addressRegion: '福島県',
        postalCode: '960-0501',
        addressCountry: 'JP',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 37.8167,
        longitude: 140.5667,
      },
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '17:00',
        },
      ],
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-home';
    script.text = JSON.stringify(schemaJsonLd);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('schema-home');
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <CompanyOverview />
      <Business />
      <Recruit />
      <News />
      <Footer />
    </div>
  );
}
